export const UPDATE_TAB_INDEX = 'fulcrum/containers/AppNavigation/UPDATE_TAB_INDEX'

const TabEnum = {
  PROJECT: {
    type: 'Project',
    value: 0
  },
  PRODUCT: {
    type: 'Product',
    value: 1
  },
  REPORT: {
    type: 'Report',
    value: 2
  },
  MANAGE: {
    type: 'Manage',
    value: 3
  },
  ADMIN: {
    type: 'Admin',
    value: 4
  }
}

export const Tab = Object.freeze(TabEnum)
